import { createComponent } from '@mtfe/sweet';
import { lazyLoadImg, common, eventBus } from '@mtfe/sweet-utils';
import tpl from './dom.html';
import style from './style.less';
import CouponInfo from './CouponInfo/script';

import { COUPON_STATUS } from '../constants/index';
import componentUtils from '../utils/index';

const { DEFAULT_DATA_SRC } = lazyLoadImg;
const { createUniqueId } = common;
const { getGiftEventName } = componentUtils;

// todo 限定商品文案
class PoiInfoI {
    constructor(props = {}) {
        this.props = props;
        this.COUPON_CONTAINER_ID = createUniqueId();
        this.LEFT_ID = createUniqueId();
        this.RIGHT_ID = createUniqueId();
        this.SCROLL_CONTAINER = createUniqueId();

        this.component = this.createDom(props);
    }
    createDom(props) {
        try {
            const { poiInfo, isLazyLoadImg = true, itemIndex } = props;
            const { onCouponBtnClick, onPoiInfoClick, onSkuClick } = props;

            if (
                !poiInfo ||
                !Array.isArray(poiInfo.skuInfoList) ||
                !poiInfo.skuInfoList.length > 0 ||
                !poiInfo.giftInfo
            ) {
                console.warn('PoiInfoI:缺乏必要参数');
                return '';
            }
            const { giftInfo, skuInfoList } = poiInfo;
            const { gift_id: giftId, status } = giftInfo;

            const eventName = getGiftEventName(giftId);
            eventBus.$on(eventName, (newStatus) => {
                this.renderCoupon(newStatus);
            });

            const data = {
                poiInfo,
                skuInfoList: skuInfoList.concat(skuInfoList),
                isLazyLoadImg,
                DEFAULT_DATA_SRC,
                LEFT_ID: this.LEFT_ID,
                RIGHT_ID: this.RIGHT_ID,
                SCROLL_CONTAINER: this.SCROLL_CONTAINER,
                COUPON_CONTAINER_ID: this.COUPON_CONTAINER_ID,
                couponDom: CouponInfo(props),
                itemIndex,
            };
            const events = {
                onPoiInfoClick: () => {
                    onPoiInfoClick && onPoiInfoClick(poiInfo);
                },
                onSkuClick: (skuIndex) => {
                    const skuInfo = skuInfoList[skuIndex];
                    onSkuClick && onSkuClick(skuInfo);
                    return false
                },
            };

            const component = createComponent(tpl, { data, style }, events);

            return component;
        } catch (error) {
            console.error(error);
            return '';
        }
    }
    getComponent() {
        return this.component;
    }
    renderCoupon(newStatus) {
        const couponDom = document.getElementById(this.COUPON_CONTAINER_ID);

        if (couponDom && newStatus === COUPON_STATUS.STATUS_RECEIVED) {
            couponDom.innerHTML = CouponInfo(this.props);
        }
    }
    ready() {
        const scrollList = document.getElementById(this.SCROLL_CONTAINER);
        const leftShadow = document.getElementById(this.LEFT_ID);
        const rightShadow = document.getElementById(this.RIGHT_ID);

        if (scrollList && leftShadow && rightShadow) {
            leftShadow.style.display = 'none';
            rightShadow.style.display =
                scrollList.scrollWidth > scrollList.clientWidth
                    ? 'block'
                    : 'none';

            scrollList.addEventListener('scroll', () => {
                // 如果滚动到最左边，隐藏左阴影
                if (scrollList.scrollLeft === 0) {
                    leftShadow.style.display = 'none';
                } else {
                    leftShadow.style.display = 'block';
                }
                // 如果滚动到最右边，隐藏右阴影
                if (
                    scrollList.scrollLeft + scrollList.clientWidth >=
                    scrollList.scrollWidth
                ) {
                    rightShadow.style.display = 'none';
                } else {
                    rightShadow.style.display = 'block';
                }
            });
        }
    }
}

export default PoiInfoI;
